/** Shared absolute timestamps, always labelled in Indian Standard Time. */
export function formatDate(value: string | null | undefined): string {
  if (!value) return 'No date';
  const date = new Date(`${value.slice(0, 10)}T00:00:00Z`);
  return Number.isFinite(date.getTime()) ? new Intl.DateTimeFormat('en-IN', { timeZone: 'UTC', dateStyle: 'medium' }).format(date) : 'Invalid date';
}

export function formatIST(value: string | null | undefined): string {
  if (!value) return 'Not recorded';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return 'Invalid date';
  return `${new Intl.DateTimeFormat('en-IN', { timeZone: 'Asia/Kolkata', dateStyle: 'medium', timeStyle: 'short' }).format(date)} IST`;
}

export function relativeTime(value: string, now = Date.now()): string {
  const ms = new Date(value).getTime() - now;
  if (!Number.isFinite(ms)) return 'Invalid date';
  const fmt = new Intl.RelativeTimeFormat('en-IN', { numeric: 'auto' });
  if (Math.abs(ms) < 60_000) return 'Just now';
  if (Math.abs(ms) < 3_600_000) return fmt.format(Math.round(ms / 60_000), 'minute');
  if (Math.abs(ms) < 86_400_000) return fmt.format(Math.round(ms / 3_600_000), 'hour');
  return fmt.format(Math.round(ms / 86_400_000), 'day');
}

export function todayIST(now = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}
